// Libs
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';

// Components
import TicketView from './TicketView';


export default React.memo(props => {
  const {
    index, ticket, style
  } = props;
  const patchedStyle = {
    ...style,
    width: '98%',
    top: style.top + 8,
    left: style.left + 8
  };

  if (!ticket) return <div />;

  return (
    <Draggable
      key={ticket.id}
      draggableId={ticket.id}
      index={index}
      isDragDisabled={props.disabledDrag}
    >
      {provided => {
        return (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              ...patchedStyle,
              ...provided.draggableProps.style
            }}
          >
            <TicketView
              ticket={ticket}
              categories={props.categories}
              enableDelete={props.enableDelete}
              isSupervisorMode={props.isSupervisorMode}
              hasRightOnPriority={props.hasRightOnPriority}
              enableUpdateStatus={props.enableUpdateStatus}
              getFootBarList={props.getFootBarList}
              updateFootBar={props.updateFootBar}
              closeFootBar={props.closeFootBar}
              updateModal={props.updateModal}
              skillName={props.skillName}
              groupBatimentName={props.groupBatimentName}
              groupFloorName={props.groupFloorName}
              groupPositionName={props.groupPositionName}
              users={props.users}
              assigners={props.assigners}
            />
          </div>
        )
      }}
    </Draggable>
  );
}, (prevProps, nextProps) => {
  return (
    prevProps.index === nextProps.index
    && prevProps.ticket.id === nextProps.ticket.id
    && prevProps.style.height === nextProps.style.height
    && prevProps.style.left === nextProps.style.left
    && prevProps.style.position === nextProps.style.position
    && prevProps.style.top === nextProps.style.top
    && prevProps.style.width === nextProps.style.width
    && prevProps.categories === nextProps.categories
    && prevProps.enableDelete === nextProps.enableDelete
    && prevProps.disabledDrag === nextProps.disabledDrag
    && prevProps.isSupervisorMode === nextProps.isSupervisorMode
    && prevProps.hasRightOnPriority === nextProps.hasRightOnPriority
    && prevProps.enableUpdateStatus === nextProps.enableUpdateStatus
    && prevProps.getFootBarList === nextProps.getFootBarList
    && prevProps.skillName === nextProps.skillName
    && prevProps.groupBatimentName === nextProps.groupBatimentName
    && prevProps.groupFloorName === nextProps.groupFloorName
    && prevProps.groupPositionName === nextProps.groupPositionName
    && prevProps.users === nextProps.users
    && prevProps.assigners === nextProps.assigners
  );
});
